<template>
    <div>
        <div class="d-flex justify-content-between flex-md-row flex-column pt-3">
            <form-select :leftIcon="['fas', 'location-dot']" label="Default Country:" class="w-100 mr-md-4"
                :options="countries" v-model="localization.default_country.id" />
            <form-select :leftIcon="['fas', 'wallet']" label="Preferred Currency:" :options="currencies" class="w-100"
                v-model="localization.client.currency.code" />
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column pt-3">
            <form-select :leftIcon="['fas', 'clock']" label="Time Format:" :options="timeFormatOptions"
                class="w-100 mr-md-4" v-model="localization.time_format" />

            <form-select :leftIcon="['fas', 'clock']" label="Time Zone:" class="w-100" :options="timezones"
                v-model="localization.timezone.id" />
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column pt-3">
            <form-select :leftIcon="['fas', 'calendar-days']" label="Date Format:" class="w-100 mr-md-4"
                v-model="localization.date_format" :options="dateFormats" />

            <form-select :leftIcon="['fas', 'calendar-days']" label="Charges Table Date Format:" class="w-100"
                v-model="localization.charges_table_date_format" :options="chargesTableDateFormats" />
        </div>
        <div>
            <div class="pt-3 pr-3">
                <span class="">Available Languages:</span>
                <div class="d-flex mt-3 flex-wrap flex-md-row flex-column justify-content-between">
                    <form-checkbox :key="language.code" v-for="language in languages" v-model="language.active">{{
                        language.name
                    }}</form-checkbox>
                </div>
            </div>
            <b-button @click="saveSettings" variant="primary" class="mt-2 save-button">Save</b-button>
        </div>
    </div>
</template>

<script>
import API from '../../api';
import FormCheckbox from '../generic/form-checkbox/form-checkbox.vue';
import FormSelect from '../generic/form-select/form-select.vue';
import page from '../generic/page/page.vue';
import { ISETTINGS_SAVE_LOCALIZATION } from '../../endpoints';
import { mapGetters } from 'vuex';

export default {
    components: { page, FormCheckbox, FormSelect },
    data() {
        return {
            busy: null,
            tabs: [
                {
                    title: 'General',
                    route: '/app/isettings/general',
                    active: false,
                },
                {
                    title: 'Bookings',
                    route: '/app/isettings/bookings',
                    active: false,
                },
                {
                    title: 'Localization',
                    route: '/app/isettings/localization',
                    active: true,
                },
                {
                    title: 'Marketing',
                    route: '/app/isettings/marketing',
                    active: false,
                },
            ],
        };
    },
    computed: {
        ...mapGetters('iSettings', [
            'countries',
            'currencies',
            'timezones',
            'dateFormats',
            'chargesTableDateFormats',
            'languages',
            'localization',
        ]),
        timeFormatOptions() {
            return [
                { text: '24 hour', value: 24 },
                { text: '12 hour', value: 12 },
            ];
        },
    },
    methods: {
        convertToSelectValues(arr) {
            return arr.map((item) => ({
                ...item,
                value: item.code,
                text: item.name,
            }));
        },
        async saveSettings() {
            const currentCountry = this.countries.find((item) => item.id === this.localization.default_country.id);
            const currentCurrency = this.currencies.find(
                (item) => item.code === this.localization.client.currency.code
            );
            const currentTimezone = this.timezones.find((item) => item.value === this.localization.timezone.id);
            try {
                this.$parent.$emit('busy', true);
                await API.post(ISETTINGS_SAVE_LOCALIZATION(), {
                    ...this.localization,
                    default_country: { ...currentCountry },
                    client: {
                        ...this.localization.client,
                        currency: { ...currentCurrency },
                    },
                    timezone: { ...currentTimezone },
                    languages: this.languages,
                });
                this.successToast({ text: 'Settings successfully updated.' });
            } catch (e) {
                console.log(e);
                this.errorToast({ text: 'Could not update settings' });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
    },
};
</script>
